import Dashboard from "./pages/dashboard/Dashboard";
import Visualization from "./pages/visualization/Visualization";
import AnalyticReport from "./pages/analytic/AnalyticReport";
import Inbound from "./pages/inbound/Inbound";
import RequestPart from "./pages/request-part/RequestPart";
import Outbound from "./pages/outbound/Outbound";
import StockOpname from "./pages/stock-opname/StockOpname";
import Warehouse from "./pages/master-data/warehouse/Warehouse";
import Rack from "./pages/master-data/rack/Rack";
import Part from "./pages/master-data/part/Part";
import Rfid from "./pages/master-data/rfid/Rfid";
import Privilege from "./pages/master-data/privilege/Privilege";
import User from "./pages/master-data/user/User";
import AccessControlList from "./pages/setting/access-control-list/AccessControlList";
import Login from "./pages/auth/Login";
import VisualizationDetail from "./pages/visualization/VisualizationDetail";
import SettingLayout from "./pages/master-data/rack/SettingLayout";
import NotificationGate from "./pages/notification/NotificationGate";
import Departement from "./pages/master-data/departement/Departement";
import Profile from "./pages/profile/Profile";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "bx bx-home-alt",
    component: <Dashboard />,
    class: "parent-icon icon-color-1",
    layout: "/admin",
  },
  {
    path: "/visualization",
    name: "Visualization",
    icon: "bx bx-conversation",
    component: <Visualization />,
    class: "parent-icon icon-color-2",
    layout: "/admin",
  },
  {
    path: "/visualization/detail/:id/:warehouse",
    name: "Visualization Detail",
    icon: "bx bx-conversation",
    component: <VisualizationDetail />,
    class: "parent-icon icon-color-2",
    layout: "/admin",
  },
  {
    path: "/analytic-report",
    name: "Analytic Report",
    icon: "bx bx-archive",
    component: <AnalyticReport />,
    class: "parent-icon icon-color-3",
    layout: "/admin",
  },
  {
    path: "/notification-gate",
    name: "Notification Gate",
    icon: "bx bx-archive",
    component: <NotificationGate />,
    class: "parent-icon icon-color-3",
    layout: "/admin",
  },
  {
    path: "/inbound",
    name: "Inbound",
    icon: "bx bx-group",
    component: <Inbound />,
    class: "parent-icon icon-color-4",
    layout: "/admin",
  },
  {
    path: "/request-part",
    name: "Request Part",
    icon: "bx bx-task",
    component: <RequestPart />,
    class: "parent-icon icon-color-5",
    layout: "/admin",
  },
  {
    path: "/outbound",
    name: "Outbound",
    icon: "bx bx-calendar-check",
    component: <Outbound />,
    class: "parent-icon icon-color-7",
    layout: "/admin",
  },
  {
    path: "/stock-opname",
    name: "Stock Opname",
    icon: "bx bx-box",
    component: <StockOpname />,
    class: "parent-icon icon-color-7",
    layout: "/admin",
  },
  {
    path: "/warehouse",
    name: "Warehouse",
    icon: "bx bx-right-arrow-alt",
    component: <Warehouse />,
    class: "",
    layout: "/admin",
  },
  {
    path: "/rack",
    name: "Rack",
    icon: "bx bx-right-arrow-alt",
    component: <Rack />,
    class: "",
    layout: "/admin",
  },
  {
    path: "/rack/setting-layout",
    name: "Rack",
    icon: "bx bx-right-arrow-alt",
    component: <SettingLayout />,
    class: "",
    layout: "/admin",
  },
  {
    path: "/part",
    name: "part",
    icon: "bx bx-right-arrow-alt",
    component: <Part />,
    class: "",
    layout: "/admin",
  },
  {
    path: "/rfid",
    name: "RFID",
    icon: "bx bx-right-arrow-alt",
    component: <Rfid />,
    class: "",
    layout: "/admin",
  },
  {
    path: "/privilege",
    name: "Privilede",
    icon: "bx bx-right-arrow-alt",
    component: <Privilege />,
    class: "",
    layout: "/admin",
  },
  {
    path: "/departement",
    name: "Departement",
    icon: "bx bx-right-arrow-alt",
    component: <Departement />,
    class: "",
    layout: "/admin",
  },
  {
    path: "/user",
    name: "User",
    icon: "bx bx-right-arrow-alt",
    component: <User />,
    class: "",
    layout: "/admin",
  },
  {
    path: "/access-control-list",
    name: "Access Control List",
    icon: "bx bx-right-arrow-alt",
    component: <AccessControlList />,
    class: "",
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "Profile",
    icon: "bx bx-user-circle",
    component: <Profile />,
    class: "",
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Login",
    icon: "bx bx-log-in",
    component: <Login />,
    class: "",
    layout: "/auth",
  },
];

export default routes;
